import React from 'react';
import NavbarComponent from '../Components/NavbarComponent';
import LowestNavbar from '../Components/LowestNavbar';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useHistory } from 'react-router-dom';
import projectBlogs from './projectBlogs';

export default function Blog() {
  const history = useHistory();

  const handleReadMore = (blog) => {
    history.push(`/blog/${blog.id}`);
    window.location.reload();
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <NavbarComponent />

      <main
        className="flex-grow-1 pt-5 mt-5 mb-4 px-3"
        style={{ backgroundColor: '#f4f7fb' }}
      >
        <Container className="pt-4 pb-5">
          <div className="text-center mb-5 pt-2">
            <h2
              className="fw-bold mb-3"
              style={{
                fontSize: '2.5rem',
                color: '#0f172a',
              }}
            >
              My Blog
            </h2>

            <p
              style={{
                fontSize: '1.05rem',
                color: '#475569',
                maxWidth: '760px',
                margin: '0 auto',
                lineHeight: '1.8',
              }}
            >
              Real projects, real system design, real engineering decisions.
              This section highlights how I build products from idea to architecture to implementation.
            </p>
          </div>

          <Row className="g-4">
            {projectBlogs.map((blog) => (
              <Col key={blog.id} xs={12} md={6} lg={6}>
                <Card
                  className="h-100 border-0 shadow-sm"
                  style={{
                    borderRadius: '20px',
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                  }}
                >
                  {blog.coverImage && (
                    <div
                      style={{
                        width: '100%',
                        height: '240px',
                        overflow: 'hidden',
                        backgroundColor: '#e2e8f0',
                      }}
                    >
                      <img
                        src={blog.coverImage}
                        alt={blog.title}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          display: 'block',
                        }}
                      />
                    </div>
                  )}

                  <Card.Body className="p-4 d-flex flex-column">
                    <div className="mb-3">
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#e2e8f0',
                          color: '#334155',
                          fontWeight: 600,
                          padding: '0.55rem 0.9rem',
                          borderRadius: '999px',
                          fontSize: '0.78rem',
                        }}
                      >
                        {blog.category}
                      </span>
                    </div>

                    <Card.Title
                      className="fw-bold mb-2"
                      style={{
                        fontSize: '1.4rem',
                        color: '#0f172a',
                        lineHeight: '1.4',
                      }}
                    >
                      {blog.title}
                    </Card.Title>

                    <p
                      className="mb-3"
                      style={{
                        fontSize: '1rem',
                        color: '#475569',
                        lineHeight: '1.7',
                      }}
                    >
                      {blog.tagline}
                    </p>

                    <Card.Text
                      style={{
                        color: '#64748b',
                        lineHeight: '1.75',
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: 4,
                        WebkitBoxOrient: 'vertical',
                        minHeight: '110px',
                      }}
                    >
                      {blog.shortDescription}
                    </Card.Text>

                    <div className="mt-3 mb-4 d-flex flex-wrap gap-2">
                      {blog.tags?.slice(0, 4).map((tag, index) => (
                        <span
                          key={index}
                          style={{
                            fontSize: '0.8rem',
                            backgroundColor: '#eff6ff',
                            color: '#1d4ed8',
                            padding: '0.4rem 0.75rem',
                            borderRadius: '999px',
                            fontWeight: 500,
                          }}
                        >
                          {tag}
                        </span>
                      ))}
                    </div>

                    <div className="mt-auto">
                      <Button
                        variant="dark"
                        onClick={() => handleReadMore(blog)}
                        style={{
                          borderRadius: '999px',
                          padding: '0.7rem 1.2rem',
                          fontWeight: 600,
                        }}
                      >
                        View →
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </main>

      <LowestNavbar />
    </div>
  );
}